export default __webpack_public_path__ + "static/media/1.bad651de.webp";